import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { Router } from '@angular/router';
import { GlobalEventsManager } from '../global-events-manager';
import { MediaChange, ObservableMedia } from '@angular/flex-layout';
import { MatDialog } from '@angular/material';
import { FeedbackDialogComponent } from '../feedback-dialog/feedback-dialog.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  watcher: any;
  isDesktopView: Boolean = true;

  image: string;
  currentYear = new Date().getFullYear();
  loading: Boolean = false;

  username = '';
  password = '';

  constructor(
    private loginService: LoginService,
    private router: Router,
    private globalEventsManager: GlobalEventsManager,
    media: ObservableMedia,
    public dialog: MatDialog
  ) {
    this.watcher = media.subscribe(({ mqAlias }: MediaChange) => {
      // For tablet and mobile
      if (mqAlias === 'sm' || mqAlias === 'xs') {
        this.isDesktopView = false;
      } else {
        this.isDesktopView = true;
      }
    });
  }

  ngOnInit() {
    // If already logged in, then skip login page
    if (localStorage.getItem('userId') !== null) {
      this.router.navigate(['my-day']);
    }
    // this.globalEventsManager.showNavBar(false);
    this.loginService.getBackground().then(image => {
      this.image = image;
    });
  }

  ngOnDestroy(): void {
    if (this.watcher.unsubscribe) {
      this.watcher.unsubscribe();
    }
  }

  doLogin() {
    this.loading = true;
    this.loginService.doLogin(this.username, this.password)
      .subscribe((data) => {
        if (data.length === 1) {
          this.loginService.check5thLogin(data[0].token).subscribe(({ feedbackCount, hasAtLeast5Logins }) => {
            this.loading = false;

            if (feedbackCount === 0 && hasAtLeast5Logins) {
              this.loginService.shouldShowFeedbackModal = true;
              this.showFeedbackDialog();
            }

            this.loadPages(data);
          }, err => {
            console.error(err);
            this.loading = false;
            this.loadPages(data);
          });
        } else {
          alert('Unauthorized Credentials');
          this.loading = false;
        }
      }
    );
  }

  loadPages(data: any): void {
    const selectedDate = new Date();
    selectedDate.setHours(0, 0, 0, 0);

    localStorage.setItem('token', data[0].token);
    localStorage.setItem('userId', data[0].id);
    localStorage.setItem('userFullName', data[0].lastName + ', ' + data[0].firstName);
    localStorage.setItem('clearance', data[0].clearance);
    localStorage.setItem('selectedDate', selectedDate.toString());
    localStorage.setItem('branch1', data[0].branch1);

    this.globalEventsManager.showNavBar(true);
    if (data[0].clearance === '1' || data[0].clearance === '2') {
      this.router.navigate(['my-day']);
    } else if (data[0].clearance === '3' || data[0].clearance === '4') {
      this.router.navigate(['my-branch']);
    } else {
      this.router.navigate(['countries']);
    }
  }

  showFeedbackDialog(): void {
    const feedbackDialogOptions: any = {
      disableClose: true,
      width: this.isDesktopView ? '600px' : '100vw'
    };

    if (!this.isDesktopView) {
      feedbackDialogOptions.panelClass = 'feedback-dialog-container';
    }

    this.dialog.open(FeedbackDialogComponent, feedbackDialogOptions).afterClosed().subscribe(() => {
      this.loginService.shouldShowFeedbackModal = false;
    });
  }

  getFormattedDate( dt: Date ): string {
    let m: any = dt.getMonth() + 1;
    m = (m < 10) ? '0' + m.toString() : m.toString();
    let d: any = dt.getDate();
    d = (d < 10) ? '0' + d.toString() : d.toString();

    return dt.getFullYear().toString() + '-' + m.toString() + '-' + d.toString();
  }

}
